import { render } from "./MLPageReview.vue?vue&type=template&id=9c462fba&scoped=true"
import script from "./MLPageReview.vue?vue&type=script&lang=js"
export * from "./MLPageReview.vue?vue&type=script&lang=js"

import "./MLPageReview.vue?vue&type=style&index=0&id=9c462fba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c462fba"]])

export default __exports__